/* eslint-disable @typescript-eslint/camelcase, camelcase */
import { ActivityDetailOffers } from '../common/__generated__/api';

export interface CurrencyFormat {
  code: string;
  symbol: string;
  format?: string;
  thousand?: string;
  precision?: number;
  decimal?: string;
}

export type OverridableCurrencyLocales = 'fr_FR' | 'de_CH' | 'de_DE' | 'es_MX' | 'fr_CA';

const overrides: { [key in OverridableCurrencyLocales]: Omit<CurrencyFormat, 'code' | 'symbol'> } = {
  fr_FR: {
    format: '%v %s'
  },
  de_CH: {
    format: '%s %v'
  },
  de_DE: {
    format: '%v %s'
  },
  es_MX: {
    format: '%s%v',
    precision: 0,
    thousand: ','
  },
  fr_CA: {
    format: '%v %s',
    decimal: ',',
    thousand: ' '
  }
};

export function getCurrencyFormat(
  locale: OverridableCurrencyLocales,
  currencyInfo?: ActivityDetailOffers.CurrencyInfo | null
): CurrencyFormat {
  let code;
  let symbol;
  if (currencyInfo) {
    code = currencyInfo.code;
    symbol = currencyInfo.symbol;
  } else {
    code = '';
    symbol = '';
  }

  return {
    code,
    symbol,
    ...overrides[locale]
  };
}
